//#region src/constants/mappings.ts
var e = {
	AF: "Africa",
	AN: "Antarctica",
	AS: "Asia",
	EU: "Europe",
	NA: "North America",
	OC: "Oceania",
	SA: "South America"
}, t = {
	Desktop: "Chat",
	Push: "Mobile Push"
}, n = {
	Desktop: "Fin Messenger (web)",
	"iOS App": "Fin Messenger (iOS)",
	"Android App": "Fin Messenger (Android)",
	Email: "Fin Messenger (email)"
}, r = {
	ai_answer: "AI answer",
	custom_answer: "Custom answer"
}, i = {
	confirmed_resolved: "Confirmed resolved",
	assumed_resolved: "Assumed resolved",
	routed_to_team: "Routed to team",
	negative_feedback: "Negative feedback",
	procedure_handoff: "Procedure handoff",
	remaining: "Unresolved"
}, a = {
	first_reply_time: "First response time",
	next_reply_time: "Next response time",
	resolution_time: "Time to resolve",
	time_to_close: "Time to close"
};
//#endregion
export { t as AVAILABLE_CHANNEL_MAPPINGS, e as AVAILABLE_CONTINENT_MAPPINGS, r as AVAILABLE_FIN_ANSWER_TYPE_MAPPINGS, i as AVAILABLE_FIN_RESOLUTION_STATE_MAPPINGS, a as AVAILABLE_SLA_TARGET_TYPE_MAPPINGS, n as STANDALONE_AVAILABLE_CHANNEL_MAPPINGS };
